module.exports = __webpack_public_path__ + "media/MotorStirling.e605ef75.mp4";